import React from 'react';
import { X, User, Calendar, Phone, Clock } from 'lucide-react';

const CalendlyModal = ({ isOpen, onClose, interviewer, time, day, duration }) => {
  if (!isOpen) return null;

  // In a real application, this would be a dynamic link based on the interviewer's Calendly
  const calendlyLink = `https://calendly.com/${interviewer.toLowerCase().replace(' ', '-')}`;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center">
      <div className="bg-card rounded-xl p-6 w-[90%] max-w-[480px] relative shadow-xl m-4">
        <button
          onClick={onClose}
          className="absolute right-4 top-[2.1rem] -translate-y-1/2 text-muted-foreground hover:text-muted-foreground transition-colors"
        >
          <X className="w-5 h-5" />
        </button>

        <div className="border-b pb-4 mb-6">
          <h2 className="text-2xl font-semibold text-foreground">Interview Details</h2>
        </div>

        <div className="space-y-6">
          <div className="flex items-start space-x-3">
            <div className="mt-1">
              <User className="w-5 h-5 text-blue-500" />
            </div>
            <div>
              <p className="text-sm font-medium text-muted-foreground">Recruiter</p>
              <p className="text-foreground mt-1">{interviewer}</p>
            </div>
          </div>
          
          <div className="flex items-start space-x-3">
            <div className="mt-1">
              <Calendar className="w-5 h-5 text-blue-500" />
            </div>
            <div>
              <p className="text-sm font-medium text-muted-foreground">Date & Time</p>
              <p className="text-foreground mt-1">{day} at {time}</p>
            </div>
          </div>

          <div className="flex items-start space-x-3">
            <div className="mt-1">
              <Clock className="w-5 h-5 text-blue-500" />
            </div>
            <div>
              <p className="text-sm font-medium text-muted-foreground">Duration</p>
              <p className="text-foreground mt-1">{duration} minutes</p>
            </div>
          </div>
          
          <div className="flex items-start space-x-3">
            <div className="mt-1">
              <Phone className="w-5 h-5 text-blue-500" />
            </div>
            <div>
              <p className="text-sm font-medium text-muted-foreground">Contact Details</p>
              <p className="text-foreground mt-1">+1 (555) 123-4567</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default CalendlyModal;